export default function Button({ as="button", href, onClick, children, className="" }) {
  const base = "inline-flex items-center justify-center rounded-xl px-4 py-2 font-semibold shadow-sm ring-1 ring-black/5 hover:shadow md:transition";
  const color = "bg-orange-600 text-white hover:bg-orange-700";
  const cls = `${base} ${color} ${className}`;
  if (as==="a") {
    return <a href={href} onClick={onClick} className={cls}>{children}</a>;
  }
  return <button onClick={onClick} className={cls}>{children}</button>;
}
